import { callbackify } from "util";

const template = require('./view/confirm.handlebars');

export class ConfirmUI {

  private id: string  = this.makeid();

  public bind(onConfirm: () => {}, onCancel: () => {}) {
    $('#' + this.id).find('[data-confirm]').on('click', () => onConfirm())
    $('#' + this.id).find('[data-cancel]').on('click', () => onCancel())
  }
  
  /**
   *
   * @param title
   * @param text
   * @param callback
   */
  public render(title: string, text: string, callback: () => void) {
    $('body').append(template({id: this.id, title, text}))
    callback();
  }

  public destroy() {
    $('#' + this.id).remove();
  }

  private makeid() {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }
}
